/**
 * @file Contains application config.
 */

export const APP_CONFIG = {
  LOCALE_DEFAULT: 'en',
  FALLBACK_LOCALE: 'en',
  LOCALES: [
    {
      key: 'en',
      translation: 'English',
    },
    {
      key: 'uk',
      translation: 'Українська',
    },
  ],
};
